import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from 'react-i18next';
import { isVideo } from '../utils/documentTypes';

/**
 * Aperçu in-app des documents vidéo (.mov) et HTML.
 * - Vidéo : balise <video controls> servie en statique (Range/seek géré par nginx).
 * - HTML  : rendu dans une <iframe sandbox> SANS allow-scripts → scripts désactivés
 *           (lecture sûre, pas d'exécution de code uploadé).
 * Le bouton "ouvrir" pointe vers l'URL statique (cohérent avec les PDF).
 */
const DocumentMediaDialog = ({ open, doc, fileUrl, onClose }) => {
  const { t } = useTranslation();
  if (!doc) return null;

  const video = isVideo(doc.file_type);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ pl: 1, minWidth: 0 }} noWrap>
          {doc.titre || doc.original_name}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
          <Button
            size="small"
            startIcon={<OpenInNewIcon />}
            onClick={() => window.open(fileUrl, '_blank', 'noopener,noreferrer')}
            sx={{ textTransform: 'none' }}
          >
            {t('documentMedia.openInNewTab')}
          </Button>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        {video ? (
          <Box
            component="video"
            src={fileUrl}
            controls
            autoPlay
            sx={{
              width: '100%',
              maxHeight: '80vh',
              borderRadius: 1,
              backgroundColor: 'black',
              display: 'block',
            }}
          />
        ) : (
          <Box
            component="iframe"
            src={fileUrl}
            title={doc.original_name}
            // sandbox vide = restriction maximale: pas de scripts, pas de same-origin
            sandbox=""
            sx={{
              width: '100%',
              height: '75vh',
              border: 'none',
              borderRadius: 1,
              backgroundColor: 'white',
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DocumentMediaDialog;
